import { fromJS } from 'immutable';
import faqArticlesEN from '../../data/faq/en/articles';
import faqCategoriesEN from '../../data/faq/en/categories';
// Faq articles
import faqArticlesFR from '../../data/faq/fr/articles';
// Faq categories
import faqCategoriesFR from '../../data/faq/fr/categories';
import { CHANGE_PAGE_ID, RESET_STATE } from './constants';

// All categories & articles translated
export const faqCategories = faqCategoriesFR.concat(faqCategoriesEN);
export const faqArticles = faqArticlesFR.concat(faqArticlesEN);

export const initialState = fromJS({
  pageId: null,
  categoryName: null,
});

function faqReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_PAGE_ID: {
      if (checkInArray(faqCategories, action.pageId))
        return state
          .set('pageId', action.pageId)
          .set('categoryName', action.pageId);
      return state.set('pageId', action.pageId);
    }
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
/**
 * @description Check if the value passed exist in the array
 * If it exist: return the content object
 * if it not exists: return null
 * @param {Array} array: the array to check
 * @param {String} value: the value that we want to retrieve inside our array
 * @return {Object|null}
 */
export function checkInArray(array, value) {
  const [currentValue] = array.filter((item) => item.name === value);
  return currentValue || null;
}

export default faqReducer;
